import { promptToaster } from '../App/actions';

/**
 * Consumed by Socket context to register listeners
 */
const paymentBatchSockethandlers = (dispatch, socket) => {
  socket.on('pbtx.error', (message) => {
    const { text } = message;
    // Sanitize the error message to prevent React serialization issues
    const sanitizedText =
      typeof text === 'string'
        ? text
        : 'An error occurred during payment batch processing';
    dispatch(
      promptToaster({
        type: 'error',
        title: 'Error',
        message: sanitizedText,
      }),
    );
  });

  socket.on('pbtx.success', () => {
    dispatch(
      promptToaster({
        type: 'success',
        title: 'Success',
        message: 'Payment batch successfully posted.',
      }),
    );
  });
};

export default paymentBatchSockethandlers;
